enum FolderTreeLoadStateEnum {
    Uninitialized,
    Loading,
    Loaded,
    ErrorLoading
}

export default FolderTreeLoadStateEnum;
